module.exports = __webpack_public_path__ + "static/media/acuvue_to_home.50f37f33.png";